export default __webpack_public_path__ + "static/media/cards.d8e1d80b.svg";